import React from "react";
import { Link } from "react-router-dom";

export default ({ message, path = "/" }) => (
  <div className="d-flex h-100 justify-content-center align-items-center flex-column m-4">
    <div className="message-text d-flex">
      <h1 className="font-weight-bold">{message} 👍 ✅</h1>
    </div>
    <div className="continue text-center mt-5">
      <Link to={path} className="btn btn-primary text-uppercase btn-lg">
        continue
      </Link>
    </div>
  </div>
);
